module.exports = __webpack_public_path__ + "img/top_quality_gloves.b1f02986.png";